var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.685,
    height: 20.16,
    viewBox: "0 0 15.685 20.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "signin-icon.a3995a42dbcd2ef3612c976e08d04142",
    d: "M3.46.27a.54.54,0,0,0-.49.54V5.76a.54.54,0,1,0,1.08,0V1.35h10.8v18H4.05V14.94a.54.54,0,0,0-1.08,0v4.95a.54.54,0,0,0,.54.54H15.39a.54.54,0,0,0,.54-.54V.81a.54.54,0,0,0-.54-.54H3.46ZM6.754,5.212a.54.54,0,0,0-.3.936L10.332,9.81H.76a.541.541,0,1,0,.05,1.08h9.522L6.459,14.543a.54.54,0,0,0,.742.785l4.86-4.59a.54.54,0,0,0,0-.785L7.2,5.363a.54.54,0,0,0-.447-.151Z",
    transform: "translate(-0.245 -0.27)",
    fill: "#f06f00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterorder);
export default __webpack_public_path__ + "static/media/footerorder.400b1dda552e6542e54c076ff3a35aac.svg";
export { ForwardRef as ReactComponent };